@if (!isUpdated && mode !== 'review') {
  <div>
    <div class="treat-summary__customize-header">
      Reward Selection
    </div>
    <div class="treat-summary__info-text">
      {{infoText}}
    </div>
    <mat-nav-list class="treat-summary__list treat-summary__customize-list">
      <mat-list-item data-testid="select-reward-template-button" (click)="summaryClicked()" (keydown.enter)="$event.target === $event.currentTarget && (summaryClicked())">
        <img matListItemAvatar alt="Gift Icon" class="treat-summary__gift-image" src="../../../assets/img/red_gift.png">
        <h4 matListItemTitle class="treat-summary__summary-header">Select a Reward Template</h4>
        <button mat-icon-button matListItemMeta>
          <img alt="Chevron Icon"
            class="treat-summary__chevron-icon"
            src="https://www.cfacdn.com/img/Spotlight/Icons/NavyChevronRounded_Icon.png">
          </button>
        </mat-list-item>
      </mat-nav-list>
    </div>
  }
  @if (!isMultiReward && type !== 'discoverTreat' && (mode === 'review' || isUpdated)) {
    <div>
      <div class="treat-summary__header">
        Reward Selection
      </div>
      <template-summary [templateName]="title"
        [type]="type"
        [imageURL]="imageURL"
        [details]="details"
        [isMobile]="isMobile"
        [isDisabled]="isDisabled"
        (onSummaryClick)="summaryClicked()">
    </template-summary>
  </div>
}
@if (isMultiReward && isUpdated) {
  <div>
    <div class="treat-summary__customize-header">
      Reward Selection
    </div>
    <div class="treat-summary__info-text">
      {{infoText}}
    </div>
    <mat-nav-list class="treat-summary__list treat-summary__customize-list">
      <mat-list-item [disableRipple]="isDisabled" data-testid="treat-summary" (click)="summaryClicked()" (keydown.enter)="$event.target === $event.currentTarget && (summaryClicked())">
        <img matListItemAvatar alt="Gift Icon" class="treat-summary__gift-image" src="../../../assets/img/red_gift.png">
        <h4 matListItemTitle class="treat-summary__selected-header">{{title}}</h4>
        @if (!isDisabled) {
          <button mat-icon-button matListItemMeta>
            <img alt="Chevron Icon"
              class="treat-summary__chevron-icon"
              src="https://www.cfacdn.com/img/Spotlight/Icons/NavyChevronRounded_Icon.png">
            </button>
          }
        </mat-list-item>
      </mat-nav-list>
    </div>
  }
